import Locale from 'element-ui/lib/locale';
import zhCN from 'element-ui/lib/locale/lang/zh-CN';
import en from 'element-ui/lib/locale/lang/en';
import zhTW from 'element-ui/lib/locale/lang/zh-TW';
import { DEFAULT_LOCALE } from './constants';

var ELEMENT_LOCALES = {
  'zh-CN': zhCN,
  en: en,
  'zh-TW': zhTW,
};

export function getElementLocaleMessages(appLocale) {
  return ELEMENT_LOCALES[appLocale] || ELEMENT_LOCALES[DEFAULT_LOCALE];
}

/** 同步 Element UI 组件语言（日期选择器、分页等） */
export function syncElementLocale(appLocale) {
  Locale.use(getElementLocaleMessages(appLocale));
}
